import { ShieldAlert } from 'lucide-react';

interface InquirySpamReasonsProps {
  reasons: string[];
  score: number | null;
}

/**
 * Why the filter held an inquiry.
 *
 * ⚠️ **Reviewing a spam queue means judging the filter, not just the enquiry.**
 * A quarantined row with no stated reason cannot be judged at all — the
 * producer is left guessing whether the tool or the sender was at fault, which
 * is how a false positive gets archived instead of released.
 *
 * Renders nothing when there is nothing to explain, so a row quarantined by
 * hand does not grow an empty red panel.
 */
export function InquirySpamReasons({ reasons, score }: InquirySpamReasonsProps) {
  if (reasons.length === 0) return null;

  return (
    <div
      className="mt-3 text-sm bg-red-50 border border-red-100 rounded-lg p-3"
      data-testid="spam-reasons"
    >
      <div className="flex items-center gap-2 font-medium text-red-800">
        <ShieldAlert className="h-4 w-4" />
        Held by the spam filter
        {score !== null && <span className="font-normal text-red-600">(score {score})</span>}
      </div>
      <ul className="mt-1.5 ml-6 list-disc text-red-700 space-y-0.5">
        {reasons.map((reason) => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
    </div>
  );
}
